import * as Personalizacion from '../common/personalizacion';
import * as BucketTools from "../common/bucket";
import * as Utilities from "../common/utilities";

const urlBucket = window.config.Statics.BucketUrl;

export const renderPreferencias = () => {
    let preferencias = JSON.parse(localStorage.getItem("obtenerPorPrioridad"));
    let cantNotasNoLeidas = localStorage.getItem("obtenerNovedades");
    let temasRecomendados = JSON.parse(localStorage.getItem("recomendarTemas"));
    let html = "";
    let css;

    //CON notas a leer. (si hay pocas, completa con Sugerencias)
    if (cantNotasNoLeidas > 0) {
        css = "nuevas";
        html = `<div class="techo floatFix">
                    <span class="subtitulo">Tus temas y autores </span>
                    <h4><span data-cantidadNota="">${cantNotasNoLeidas}</span> nuevas notas </h4>
                    <a href="/lo-que-sigo"> Configurar </a>
                </div>`;

        //Articles (Por nueva regla de negocio en Nota solo se muestran las Preferencias sin completar con Sugerencias.)
        const soloPreferencias = preferencias.filter(p => p.origen === "Preferencia");
        html += loopArticles(soloPreferencias, 8);

        //Botones
        html += `<div class="ver-mas">
                    <a href="/lo-que-sigo">VER MÁS NOTAS</a>
                 </div>`;
    } else if (preferencias.length === 0) {
        //SIN Preferencias NI Sugerencias.
        css = "sin-seguir";
        html = `<div class="techo floatFix">
                    <h4>SEGUÍ LOS TEMAS Y AUTORES QUE <b>MÁS TE INTERESAN</b></h4>
                </div>
                <p> Buscá el botón: <span class="seguir">SEGUIR</span> para guardarlos en tus favoritos y enterate, al instante, cada vez que haya nuevas notas.</p>
                <section class="mas-seguidos">
                <h5> MIENTRAS PODES SEGUIR ESTOS TEMAS:</h5>`;

        for (let tema of temasRecomendados) {
            const id = tema[0],
                idTipo = tema[3];

            html += `<div class="tema floatFix"><p>${tema[5]}</p>
                 <button class="seguir" data-preferibleId="${id}" data-preferibleTipoId="${idTipo}">SEGUIR</button></div>`;
        }
        html += `</section>`;
    } else {
        //SIN nota a leer (Llenar con sugerencias)
        css = "recomendadas";
        html += `<div class="techo floatFix">
                    <span class="subtitulo">Tus temas y autores </span>
                    <h4>RECOMENDADOS</h4>
                    <a href="/lo-que-sigo"> Configurar </a>
                </div>`;
        //Articles
        html += loopArticles(preferencias, 8);
        //Botones
        html += `<div class="ver-mas">
                    <a href="/lo-que-sigo">VER MÁS NOTAS</a>
                </div>`;
    }

    const asideBloque2 = document.querySelector("#bloque-2");
    asideBloque2.classList.add(css);
    asideBloque2.innerHTML = html;
    Personalizacion.seguirDejarSeguir(document.querySelectorAll('button[class="seguir"]'));
}

const loopArticles = (notas, cantidadATomar) => {
    const valueToSlice = notas.length < cantidadATomar ? notas.length : cantidadATomar;
    notas = notas.filter(n => n.datos != undefined);
    
    //Para test de render nota opinion
    //notas = notas.filter(n => n.datos.template.id === 3);

    let html = "";
    let toi = 701;
    for (let nota of notas.slice(0, valueToSlice)) {
        const notaDato = nota.datos;
        const esNotaOpinion = notaDato.template.id === 3;

        const isNotaRecomendada = nota.origen === "Sugerencia" ? "recomendadas" : "";
        const tipoOrigenNotas = isNotaRecomendada === "" ? "preferencias" : "recomendadas";

        let imagenSrc = "";
        let autorUrl = "";

        if (esNotaOpinion) {
            if (notaDato.autores !== undefined && notaDato.autores !== null && notaDato.autores.length > 0 && notaDato.autores[0].imagen !== undefined && notaDato.autores[0].imagen != null && notaDato.autores[0].imagen.id > 0 && notaDato.autores[0].imagen.extension != null && notaDato.autores[0].imagen.extension != "") {
                imagenSrc = `<img src="${BucketTools.urlBucketBalance(urlBucket, notaDato.autores[0].imagen.id, "", 90, notaDato.autores[0].imagen.extension)}"/>`;
                
            }   
            if (notaDato.autores !== undefined && notaDato.autores !== null && notaDato.autores.length > 0 && notaDato.autores[0].nombre != null && notaDato.autores[0].id != null && notaDato.autores[0].id > 0) {
                const url = Utilities.formatoUrlAcuAutor(notaDato.autores[0].nombre, notaDato.autores[0].id);

                autorUrl = `<a href="${url}" class="autor">${notaDato.autores[0].nombre}</a>`;
            }
        } else {
            imagenSrc = (notaDato.imagen && notaDato.imagen !== undefined && notaDato.imagen != null && notaDato.imagen.id > 0 && notaDato.imagen.extension != null && notaDato.imagen.extension != "")
                ? `<img src="${BucketTools.urlBucketBalance(urlBucket, notaDato.imagen.id, 80, "", notaDato.imagen.extension)}"/>`
                : "";
        }

        const notaUrl = nota.contenido_id + "-" + Utilities.FormatearUrl(nota.titulo),
            tags = notaDato.temas;
        let tag;
        let tagHtml = "";

        if (tags && tags.length > 0) {
            tag = tags[0];
            tagHtml = `<h3 class="tag"><a href="${Utilities.formatoUrlAcuTag(tag.descripcion, tag.id)}">${tag.descripcion}</a></h3>`;
        }
        let toiPos = "toi".concat(toi.toString());
        html += `<article title="" class="nota m ${esNotaOpinion ? " autor" : " foto"} floatFix ${isNotaRecomendada}" data-id="${nota.contenido_id}" data-notaid="${nota.contenido_id}" data-source="${tipoOrigenNotas}" data-pos="${toiPos}">
                    <a href="${notaUrl}" class="figure">
                        ${imagenSrc}
                    </a>`;

        if (!esNotaOpinion) {
            html += tagHtml;
            html += `<h2>
                        <a href="${notaUrl}">${nota.titulo}</a>
                        </h2>`;
        } else {
            html += `<h2>
                        <a href="${notaUrl}">${nota.titulo}</a>
                        </h2>
                        ${autorUrl}`;
        }
        html += `</article>`;
        toi++;
    }
    return html;
}

//CUANDO NO SIGO NADA se dibuja esto.
export const sugerenciasNoSigoNada = (temasRecomendados) => {
    const css = "sin-seguir";
    let html = `<div class="techo floatFix">
                    <h4>SEGUÍ LOS TEMAS Y AUTORES QUE <b>MÁS TE INTERESAN</b></h4>
                </div>
                <p> Buscá el botón: <span class="seguir">SEGUIR</span> para guardarlos en tus favoritos y enterate, al instante, cada vez que haya nuevas notas.</p>
                <section class="mas-seguidos">
                <h5> MIENTRAS PODES SEGUIR ESTOS TEMAS:</h5>`;

    for (let tema of temasRecomendados) {
        const id = tema[0],
            idTipo = tema[3];

        html += `<p>${tema[5]}</p>
                 <button class="seguir" data-preferibleId="${id}" data-preferibleTipoId="${idTipo}">SEGUIR</button>`;
    }

    html += `</section>`;
    
    const asideBloque2 = document.querySelector("#bloque-2");
    asideBloque2.classList.add(css);
    asideBloque2.innerHTML = html;
    Personalizacion.seguirDejarSeguir(document.querySelectorAll('button[class="seguir"]'));
}


// WEBPACK FOOTER //
// ./Statics/scripts/nota/preferencias.js